$(document).ready(function () {
    //$('select').selectric();

    $('#navToggle').click(function () {
        $(this).toggleClass('open');
        $('header .hide').slideToggle();
        // $('#mainMenu').toggleClass('open');
    });

    $(".tabs .tab-title:first").addClass("active");
    $(".tab-content:first").css("display", "block");
    $(".tabs .tab-title").click(function () {
        var el = $(this).index();
        if (!$(this).hasClass('active')) {
            $(".tabs .tab-title").removeClass("active");
            $(this).addClass("active");
            $(this).parents('.tabs-block').find('.tab-content').slideUp(0).eq(el).slideDown(0);
        }
    });

    $('.open_form').click(function () {
        $(this).toggleClass('active');
        $('.searchform').toggle();
    });

    $('.has-children span').click(function () {
        $(this).parent().toggleClass('active');
        console.log('work');
        $(this).parent().find('ul').fadeToggle();
    });
  /*
    $('.cart_link').click(function () {
        $('.cart_popup').toggle();
    });

    $(document).on("click", function(event){
        if(!$(event.target).closest(".h_wrap_cart").length){
            $(".cart_popup").hide();
        }
    }); */
    var instagramSlider = new Swiper('.slider-instagram .swiper-container', {
        slidesPerView: 5,
        // slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        spaceBetween: 32,
        navigation: {
            nextEl: '.slider-instagram .button-next',
            prevEl: '.slider-instagram .button-prev',
        },
        breakpoints: {
            // when window width is >= 320px
            320:{
                slidesPerView: 1,
                spaceBetween: 20,
                // slidesPerColumn: 2
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 20
            },
            // when window width is >= 480px
            1024: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            // when window width is >= 640px
            1279: {
                slidesPerView: 4,
                spaceBetween: 40
            }
        },
    });
});

$(window).on('load', function () {
  
  var hometestimonial = new Swiper('.home-quotes', {
      spaceBetween: 30,
      slidesPerView: 1,
      centeredSlides: false,
      loop: true,
      navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
  
    var swiper = new Swiper('.home_top_slider1', {
        speed: 500,
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    var galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        slidesPerView: 4,
        slidesPerColumn: 5,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });
    var galleryTop = new Swiper('.gallery-top', {
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        thumbs: {
            swiper: galleryThumbs
        }
    });
  /**customize product page***/
//       var custompdpThumbs = new Swiper('.gallery-thumbs-cust', {
//         spaceBetween: 10,
//         slidesPerView: 4,
//         slidesPerColumn: 5,
//       	slidesPerGroup: 4,
//         freeMode: true,
//         watchSlidesVisibility: true,
//         watchSlidesProgress: true,
//     });
//     var custompdpTop = new Swiper('.gallery-top-cust', {
//         spaceBetween: 10,
//         navigation: {
//             nextEl: '.swiper-button-next',
//             prevEl: '.swiper-button-prev',
//         },
//         thumbs: {
//             swiper: custompdpThumbs
//         }
//     });
//   function disableprevnextcheck(){ 
//     var activeimgposition = $('.product-thumbnails-wrapper .product-thumbnail.active').attr('data-position');
//     if(activeimgposition == 1){
//      $('.customize_product_prev').addClass('disable_prev');
//     }else{
//      $('.customize_product_prev').removeClass('disable_prev');
//     }
//     var lastimgposition = $('.product-thumbnails-wrapper .product-thumbnail.active').attr('data-last');
//     if(lastimgposition == 'last'){
//       $('.customize_product_next').addClass('disable_next');
//     }else{
//      $('.customize_product_next').removeClass('disable_next');
//     }
//   }
// // disableprevnextcheck();
//   $('.product-thumbnails-wrapper .product-thumbnail img').click(function(){
//     setTimeout(function(){ 
//       var activeimgposition = $('.product-thumbnails-wrapper .product-thumbnail.active').attr('data-position');
//       if(activeimgposition == 1){
//       // $('.customize_product_prev').addClass('disable_prev');
//       }else{
//        //$('.customize_product_prev').removeClass('disable_prev');
//       }
//       var lastimgposition = $('.product-thumbnails-wrapper .product-thumbnail.active').attr('data-last');
//       if(lastimgposition == 'last'){
//      //$('.customize_product_next').addClass('disable_next');
//       }else{
//        //$('.customize_product_next').removeClass('disable_next');
//       }
//     }, 1);
//   });

  $('.customize_product_prev').click(function(){
    var activeimgposition = $('.product-thumbnails-wrapper .product-thumbnail.active').attr('data-position');
    if(activeimgposition == 1){
      $('.product-thumbnails-wrapper .product-thumbnail').each(function(){
        var lastchecker = $(this).attr('data-last');
        if(lastchecker == 'last'){
          $(this).find('img').trigger('click');
        }
      });
    }else{
      $('.customize_product_prev').removeClass('disable_prev');
      $('.product-thumbnails-wrapper .product-thumbnail.active').prev().find('img').trigger('click');
    }
  });
  $('.customize_product_next').click(function(){
    var lastimgposition = $('.product-thumbnails-wrapper .product-thumbnail.active').attr('data-last');
    if(lastimgposition == 'last'){
      $('.product-thumbnails-wrapper .product-thumbnail').each(function(){
        var firstchecker = $(this).attr('data-position');
        if(firstchecker == 1){
          $(this).find('img').trigger('click');
        }
      });
    }else{
      $('.product-thumbnails-wrapper .product-thumbnail.active').next().find('img').trigger('click');
      $('.customize_product_next').removeClass('disable_next');
    }   
  });
  $('.swatch_Material .swatch-element label').click(function(){
    setTimeout(function(){  
      var newfeatureimg = $('.product-main-image img').attr('src');
      $('.product-thumbnails-wrapper .product-thumbnail img').each(function(){
        var caimg= $(this).attr('data-original').replace('_1024x1024', '').replace('//','https://');
        if(newfeatureimg == caimg){
          $(this).trigger('click');
        }
      }); 
    }, 1);
  });
  $('.single-option-selector').on('change',function(event){
    // console.log('gdhdb');
    event.preventDefault(); 
    setTimeout(function(){  
      var newfeatureimg = $('.product-main-image img').attr('src');

      console.log(newfeatureimg);


    }, 1);
  });
  /** end customize product page***/
});

// $(document).ready(function () {
//   document.querySelector('.single-option-selector').addEventListener("change", function(){
//   console.log('ned');
// });
// $('.single-option-selector').change(function(){
//   console.log('gdhdb');
//   setTimeout(function(){  
//     var newfeatureimg = $('.product-main-image img').attr('src');
//     console.log(newfeatureimg);
//     $('.product-thumbnails-wrapper .product-thumbnail img').each(function(){
//       var caimg= $(this).attr('data-original').replace('_1024x1024', '').replace('//','https://');
//       if(newfeatureimg == caimg){
//         $(this).trigger('click');
//       }
//     }); 
//   }, 100);
// });
// });

// Customizer page
$(window).on('load', function () {
  var curloc = window.location.href;
  if( (curloc.indexOf('/pages/customize') > -1) && (curloc.indexOf('#') > -1) ){
    var selectedcustomcol = curloc.split('#')[1];
    console.log(selectedcustomcol);
    $('#first ul.tabs li').each(function(){
      var datali = $(this).attr('data-li');
      if(datali == selectedcustomcol){
        $(this).trigger('click');
      }
    });
  }
});
$(window).on('hashchange', function(e){
  var curloc = window.location.href;
  if( (curloc.indexOf('/pages/customize') > -1) && (curloc.indexOf('#') > -1) ){
    location.reload(true);
    var selectedcustomcol = curloc.split('#')[1];
    console.log(selectedcustomcol);
    $('#first ul.tabs li').each(function(){
      var datali = $(this).attr('data-li');
      if(datali == selectedcustomcol){
        $(this).trigger('click');
      }
    });
  }
});

$(window).on('load', function () {
  $('#product-message-actual_1').val('');
  $('#product-message-actual_2').val('');
  $('#product-message-actual_3').val('');
  $('#product-message-actual_4').val('');
  var currentlocation = window.location.href;
  var charCodes={" ":"/","a":" . - ","b":" - . . . ","c":" - . - . ","d":" - . . ","e":" . ","f":" . . - . ","g":" - - . ","h":" . . . . ","i":" . . ","j":" . - - - ","k":" - . - ","l":" . - . . ","m":" - - ","n":" - . ","o":" - - - ","p":" . - - . ","q":" - - . - ","r":" . - .","s":" . . . ","t":" - ","u":" . . - ","v":" . . . - ","w":" . - - ","x":" - . . - ","y":" - . - - ","z":" - - . . ","1":" . - - - - ","2":" . . - - - ","3":" . . . - - ","4":" . . . . - ","5":" . . . . . ","6":" - . . . . ","7":" - - . . . ","8":" - - - . . ","9":" - - - - . ","0":" - - - - - "}
  if( (currentlocation.indexOf('/products') > -1) && (currentlocation.indexOf('?personalized_message=') > -1)){
	$('.customize-progress-steps_product').show();
    var message = currentlocation.split('?personalized_message=')[1];
    var message1 = message.split('&personalized_message1=')[0];
    message1 = message1.replace(/%20/g,' ');
    var messagenew = message.split('&');
    var message2 = messagenew[1];
    var message3 = messagenew[2];
    var message4 = messagenew[3];
    
    if((currentlocation.indexOf('&personalized_message1=') > -1) && (currentlocation.indexOf('&personalized_message2=') > -1)){
      if(message2.indexOf('personalized_message1=') > -1 ){
        message2 = message2.split('personalized_message1=')[1];
        message2= message2.replace(/%20/g,' ');
      }
      if(message3.indexOf('personalized_message2=') > -1 ){
        message3 = message3.split('personalized_message2=')[1];
        message3= message3.replace(/%20/g,' ');
      }
      if(message4.indexOf('personalized_message3=') > -1 ){
        message4 = message4.split('personalized_message3=')[1];
        message4= message4.replace(/%20/g,' ');
      }
      $('#product-message-1').val(message1);
      $('#product-message-2').val(message2);
      $('#product-message-3').val(message3);
      $('#product-message-4').val(message4);
      $('.custom_messages_container').show();
    //  $('.Message_txt2_row').show();
    //  $('.Message_txt3_row').show();
    }
    else if(currentlocation.indexOf('&personalized_message1=') > -1){
      if(message2.indexOf('personalized_message1=') > -1 ){
        message2 = message2.split('personalized_message1=')[1];
        message2= message2.replace(/%20/g,' ');
      }
      $('#product-message-1').val(message1);
      $('#product-message-2').val(message2);
      
      $('.custom_messages_container').show();
    //  $('.Message_txt2_row').show();
    }
    else{
      if(message.length > 6){
        if(message.indexOf('&stepone_title') > -1){
          message= message.split('&stepone_title')[0];
        }
        message= message.replace(/%20/g,' ');
     //   message = message.slice(0,8);
        $('.custom_messages_container').show();
        $('#product-message-1').val(message);
      }
      else{  
        $('.custom_messages_container').show();
        $('#product-message-1').val(message);
      }

      //       var checkval = $('#product-message-1').val();
      //       if(checkval){
      //         var chars = checkval.toLowerCase().split("");
      //         var translated = "";

      //         for ( a = 0; a < chars.length; a++){
      //           translated += charCodes[chars[a]];
      //         }
      //         document.getElementById("translated-message-1").value = translated;
      //       }
    }

    if(currentlocation.indexOf('&stepone_title=') > -1){
       var category_of_product = currentlocation.split('&stepone_title=')[1];
      category_of_product = category_of_product.split('&')[0];
      category_of_product= category_of_product.replace(/%20/g,' ');
      $('.step_one_customize .Custom_product_title').text(category_of_product);
    }
    if(currentlocation.indexOf('&steptwo_title=') > -1){
       var style_of_product = currentlocation.split('&steptwo_title=')[1];
      style_of_product = style_of_product.split('&')[0];
      style_of_product = style_of_product.replace(/%20/g,' ');
      $('.step_two_customize .Custom_product_title').text(style_of_product);
    }
    $('.step_three_customize .Custom_product_title').text('Personalize Message');
    

   //hide message display if no personalized messages appear
  }

  
});

$(document).ready(function () {

  $('.first_input').click(function(){
     jQuery('.cstm0').addClass('cstm_select_img');
    jQuery('.cstm11').addClass('cstm_select_img');
    jQuery('.cstm19').addClass('cstm_select_img');
    jQuery('.cstm43').addClass('cstm_select_img');
    jQuery('.cstm64').addClass('cstm_select_img');
    jQuery('.cstm71').addClass('cstm_select_img');
    jQuery('.cstm71').addClass('cstm_select_img');
    jQuery('.cstm78').addClass('cstm_select_img');
    
    var first_imgs = $('.current').find(' .cstm_select_img .product_image_container').children('.product-list-item-thumbnail ').find('img').data('img');
    $('.current').find('.cstm-thumb').children('img').attr('src',first_imgs);
    
    
    
    $("html, body").animate({ scrollTop: 0 }, "fast");
    var selected_category_tab_number = $('.tab-link.current').attr('data-tab');
    var selected_category_title = $('.tab-link.current').text();
    $('#'+selected_category_tab_number).find('.common_slider_check').addClass('customized_collection_slider');
    $('#'+selected_category_tab_number).find('.common_slider_check_top').addClass('customized_collection_slider_top');
	$('.step_one_customize .Step_title').text(selected_category_title);
    
    // setTimeout(function(){ 
    var nextswiper = new Swiper('.customized_collection_slider', {
      slidesPerView: 4,
      spaceBetween: 10,
      slidesPerGroup: 1,
      freeMode: false,
      //loop: true,
//       threshold:1000,
//       preventClicks: false,
//       preventClicksPropagation: false,
     allowTouchMove : false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        320: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        480: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        766: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        992: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        }
      },
      pagination: {
        el: '.swiper-pagination',
//         type: 'fraction',
//         renderFraction: function (currentClass, totalClass) {
//           return '<span class="' + currentClass + '"></span>' +
//             ' / ' +
//             '<span class="' + totalClass + '"></span>';
//         }
//         type: 'custom',
//         renderCustom: function (swiper, current, total) {
//           var lastactive =   current+3;
//           if(lastactive<total){
//             return current+'-'+lastactive + ' / ' + total;
//           }else{
//             return current+'-'+total + ' / ' + total;
//           }
//         }
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          
            return current+ ' / ' + total;
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
    var nextswiperTop = new Swiper('.customized_collection_slider_top', {
      spaceBetween: 10,
      loop: true,
      effect: 'fade',
      autoHeight: true,
      thumbs: {
        swiper: nextswiper
      }
    });
    var newtxt = $('.swiper-slide-thumb-active .overview').html();
    $('#'+selected_category_tab_number+' .selectedproduct_info').html(newtxt);

    // }, 3000);

      $('.customized_collection_slider .swiper-slide').click(function(){
   var newtxt = $('.swiper-slide-thumb-active .overview').html();
//         consol.log(newtxt);
    $('#'+selected_category_tab_number+' .selectedproduct_info').html(newtxt);
  });
    $('.prev-to-collection').click(function(){
      nextswiperTop.destroy();
      nextswiper.destroy(); 
//       jQuery('.csstm1').addClass('cstm_select_img');
         $('.swiper-slide').removeClass('cstm_select_img');

      $('.customized_collection_slider .swiper-slide').removeClass('.cstm_select_img');
      $('.common_slider_check.customized_collection_slider').removeClass('customized_collection_slider');
      $('.common_slider_check_top.customized_collection_slider_top').removeClass('customized_collection_slider_top');      
   	  $('.step_one_customize .Step_title').text($(this).attr("data-text"));
       $("html, body").animate({ scrollTop: 0 }, "fast");
    });
     
  });

  
  $('.second_input').click(function(){
 //   console.log('in');
	$("html, body").animate({ scrollTop: 0 }, "fast");
    var selected_style_title = $('.customized_collection_slider .cstm_select_img .overview h3').text().toLowerCase();
    var urlforjson = $('.customized_collection_slider .cstm_select_img .product-list-item-details h3 a').attr('href');
    $('.step_two_customize .Step_title').text(selected_style_title);
    $('#third h1').text('Personalize Message');
    $('.step_three_customize .Step_title').text('Personalize Message');
    var max_char_l = $('.customized_collection_slider .cstm_select_img .overview .charlength').text()
    $('#product-message-actual_1, #product-message-actual_2, #product-message-actual_3, #product-message-actual_4').attr('maxlength', max_char_l);
    $('#product-message-actual_1, #product-message-actual_2, #product-message-actual_3, #product-message-actual_4').attr('placeholder', 'Type here: '+max_char_l+' Character Max');
    for(i = 1; i <= 16; i++) { 
      $('#product-message-translated_1_'+i).hide().removeClass('last_char');
      $('#product-message-translated_2_'+i).hide().removeClass('last_char');
      $('#product-message-translated_3_'+i).hide().removeClass('last_char');
      $('#product-message-translated_4_'+i).hide().removeClass('last_char');
    }
    for(i = 1; i <= max_char_l; i++) {
      $('#product-message-translated_1_'+i).show();
      $('#product-message-translated_2_'+i).show();
      $('#product-message-translated_3_'+i).show();
      $('#product-message-translated_4_'+i).show();
      if(i == max_char_l){
        $('#product-message-translated_1_'+i).addClass('last_char');
        $('#product-message-translated_2_'+i).addClass('last_char');
        $('#product-message-translated_3_'+i).addClass('last_char');
        $('#product-message-translated_4_'+i).addClass('last_char');
      }
    }
    
    jQuery.ajax({
      type: 'GET',
      url: urlforjson+'.json',
      dataType: 'json',
      cache: false,
      success: function (data) {
        var alltags= data.product.tags;
        if((alltags.indexOf('2-message') > -1) || (alltags.indexOf('3-message') > -1)){
      //    console.log('2/3');
         $('.add_additional_btn_1').hide();
          $('#add_more_btn_1').hide();
          $('.add_additional_btn_2').hide();
          $('.additional_message_row_1').show();
          $('.add_additional_btn_2').show();
          $('.additional_message_row_1').addClass('required_row');
        }
        if(alltags.indexOf('3-message') > -1){
           $('.add_additional_btn_2').addClass('nonextmesg');
          $('#add_more_btn_2').hide();
          $('.additional_message_row_2').show();
          $('.additional_message_row_2').addClass('required_row');
        }else{
          $('.add_additional_btn_2').removeClass('nonextmesg');
        }
        if(alltags.indexOf('4-message') > -1){
          $('.additional_message_row_3').show();
          $('.additional_message_row_3').addClass('required_row');
        }else{
          $('.add_additional_btn_2').removeClass('nonextmesg');
        }
      },
       beforeSend: function(){
        $('body').addClass('loader');
      },
      complete: function(){
        $('body').removeClass('loader');        
      }
    });
       
    $('.prev-to-msg').click(function(){
      $('.step_two_customize .Step_title').text($(this).attr("data-text"));
      $('#product-message-actual_1').val('');
      $('.trans_input input').val('');
      $('#product-message-actual_2').val('');
      $('#product-message-actual_3').val('');
      $('#product-message-actual_4').val('');
      $('.additional_message_row_1').hide();
      $('.additional_message_row_1').removeClass('required_row');
      $('.additional_message_row_2').hide();
      $('.additional_message_row_2').removeClass('required_row');
      $('.additional_message_row_3').hide();
      $('.additional_message_row_3').removeClass('required_row');
      $("html, body").animate({ scrollTop: 0 }, "fast");
    });
  });
  
  $('#add_more_btn_1').click(function(){
    $(this).hide();
//     $('.additional_message_row_1').show();
//     $('.add_additional_btn_2').show();
//     $('.additional_message_row_1').addClass('required_row');
  });
  
  $('#add_more_btn_2').click(function(){
    $(this).hide();
//     $('.additional_message_row_2').show();
//     $('.additional_message_row_2').addClass('required_row');
  });

  $('.item_link').click(function(){
	console.log('tt');
    var productlink = $('.customized_collection_slider  .swiper-slide-thumb-active').attr('data-action');
    var stepone_title = $('.step_one_customize .Step_title').text();
    var steptwo_title = $('.step_two_customize .Step_title').text();
    var personalized_msg = $('#product-message-actual_1').val();
    var input_personalized_message = $('#product-message-actual_1').val();
    var secmsgval = $('#product-message-actual_2').val();
    var thirdmsgval = $('#product-message-actual_3').val();
    var fourthmsgval = $('#product-message-actual_4').val();
    var messagerequiredError = false;
    var messagerequiredError1 = false;
    var messagerequiredError2 = false;
    var messagerequiredError3 = false;
    if (input_personalized_message == ''){
      messagerequiredError = true;  
    }
    if(messagerequiredError) {
      document.getElementById("product-message-required-error").style.display = "block";
      return true;
    } else {
      document.getElementById("product-message-required-error").style.display = "none";
    }
    // for 2nd and 3rd msg
    if($('.additional_message_row_1').hasClass('required_row')){
     
      if(secmsgval == ''){
        messagerequiredError1 = true;
      }
      if(messagerequiredError1){
        $('#product-message-required-error_1').show();
        return true;
      }else{
        $('#product-message-required-error_1').hide();
      }
    }
    if($('.additional_message_row_2').hasClass('required_row')){
      
      if(thirdmsgval == ''){
        messagerequiredError2 = true;
      }
      if(messagerequiredError2){
        $('#product-message-required-error_2').show();
        return true;
      }else{
        $('#product-message-required-error_2').hide();
      }
    }
    if($('.additional_message_row_3').hasClass('required_row')){
      
      if(fourthmsgval == ''){
        messagerequiredError3 = true;
      }
      if(messagerequiredError3){
        $('#product-message-required-error_3').show();
        return true;
      }else{
        $('#product-message-required-error_3').hide();
      }
    }
    if(!messagerequiredError && !messagerequiredError1 && !messagerequiredError2 && !messagerequiredError3){
      if(input_personalized_message != '' && thirdmsgval == '' && secmsgval == '' && fourthmsgval == '' ){
	    window.location.href = productlink+'?personalized_message='+personalized_msg+'&stepone_title='+stepone_title+'&steptwo_title='+steptwo_title;
      }
      else if(input_personalized_message != '' && secmsgval != '' && thirdmsgval == '' && fourthmsgval == '' ){
         window.location.href = productlink+'?personalized_message='+personalized_msg+'&personalized_message1='+secmsgval+'&stepone_title='+stepone_title+'&steptwo_title='+steptwo_title;
      }
      else if(input_personalized_message != '' && secmsgval != '' && thirdmsgval != '' && fourthmsgval == '' ){
         window.location.href = productlink+'?personalized_message='+personalized_msg+'&personalized_message1='+secmsgval+'&personalized_message2='+thirdmsgval+'&stepone_title='+stepone_title+'&steptwo_title='+steptwo_title;
      }
     else if(input_personalized_message != '' && secmsgval != '' && thirdmsgval != '' && fourthmsgval != '' ){
         window.location.href = productlink+'?personalized_message='+personalized_msg+'&personalized_message1='+secmsgval+'&personalized_message2='+thirdmsgval+'&personalized_message3='+fourthmsgval+'&stepone_title='+stepone_title+'&steptwo_title='+steptwo_title;
      }  
    }
    
  });
  
  // code for message translation 
  var charCodes = {
    " " : "/","a" : " . - ",
    "b" : " - . . . ",
    "c" : " - . - . ",
    "d" : " - . . ",
    "e" : " . ",
    "f" : " . . - . ",
    "g" : " - - . ",
    "h" : " . . . . ",
    "i" : " . . ",
    "j" : " . - - - ",
    "k" : " - . - ",
    "l" : " . - . . ",
    "m" : " - - ",
    "n" : " - . ",
    "o" : " - - - ",
    "p" : " . - - . ",
    "q" : " - - . - ",
    "r" : " . - .",
    "s" : " . . . ",
    "t" : " - ",
    "u" : " . . - ",
    "v" : " . . . - ",
    "w" : " . - - ",
    "x" : " - . . - ",
    "y" : " - . - - ",
    "z" : " - - . . ",
    "1" : " . - - - - ",
    "2" : " . . - - - ",
    "3" : " . . . - - ",
    "4" : " . . . . - ",
    "5" : " . . . . . ",
    "6" : " - . . . . ",
    "7" : " - - . . . ",
    "8" : " - - - . . ",
    "9" : " - - - - . ",
    "0" : " - - - - - "                     
  }

  function setupTranslationForProductmessageNum(num) {
    var el = document.getElementById("product-message-actual_" + num);

    if(el) {
      el.addEventListener("focus", function(){
        this.value = "";
      });

      el.addEventListener("keyup", function() { 
        var value = el.value;
        var chars = value.toLowerCase().split("");
        var translated = "";
        var b= 1;
        // to clear out extra words from translated text
        for (var c = chars.length; c < 16; c++){
          var actualcharnum = c+b;
          document.getElementById("product-message-translated_" +num+"_"+actualcharnum).value = '';
        }
        // to translate character typed
        for (var a = 0; a < chars.length; a++){
          translated[a] = charCodes[chars[a]];
          var actualcharnum = a+b;           
          document.getElementById("product-message-translated_" +num+"_"+actualcharnum).value = charCodes[chars[a]];
        }
      });
    }
  }
  setupTranslationForProductmessageNum(1);
  setupTranslationForProductmessageNum(2);
  setupTranslationForProductmessageNum(3);
  setupTranslationForProductmessageNum(4);
});

$(document).ready(function (){
  //pdp
  jQuery('.qtyminus, .qtyplus').click(function(){
    if(jQuery(this).data('action')=='dec'){
      var oldqty=jQuery(this).next('input').val();
      if(oldqty>1){
        var newqty=parseInt(oldqty)-1;
        jQuery(this).next('input').val(newqty);
        jQuery(this).next('input').change();
      }
    }else if(jQuery(this).data('action')=='inc'){
      var oldqty=jQuery(this).prev('input').val();
      var newqty=parseInt(oldqty)+1;
      jQuery(this).prev('input').val(newqty);
      jQuery(this).prev('input').change();
    }
  });
$("input[name='updates[]']").on('change', function() {
      $( "input[name='update']" ).trigger( "click" );
    });
  
  
  
  
//   $('.slides_brands').slick({
      
//         infinite: true,
//         slidesToShow: 1,
//         slidesToScroll: 1,
//           dots: false,
//     draggable: false,
//         prevArrow: '.customize_product_prev',
//         nextArrow: '.customize_product_next',
//       asNavFor: '.slider-nav'
//     });
  
//   $('.slider-nav').slick({
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   asNavFor: '.slides_brands',
//    dots: false,
//   centerMode: false,
//   focusOnSelect: true,
//     prevArrow: false,
//         nextArrow: false,
    
// });
  
});




mobileOnlySlider(".cont_main_slide", true, false, 891);

function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
	var slider = $('.cont_main_slide');
	var settings = {
		mobileFirst: true,
		dots: $dots,
		arrows: false,
		responsive: [
			{
				breakpoint: $breakpoint,
				settings: "unslick"
			}
		]
	};
$(document).ready(function (){
	$('.cont_main_slide').slick(settings);
});
	$(window).on("resize", function () {
		if ($(window).width() > $breakpoint) {
			return;
		}
		if (!slider.hasClass("slick-initialized")) {
			return slider.slick(settings);
		}
	});
} // Mobile Only Slider
